import React, { Component } from 'react'
import { Alert } from 'react-bootstrap'

export default class TopBar extends Component {
  defaultProps = {
    bsStyle: 'danger'
  }

  render () {
    const { className, children, bsStyle } = this.props
    return (
      <Alert bsStyle={bsStyle} className={`top-bar ${className}`}>
        {children}
      </Alert>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/topBars/topBar.js